export default __webpack_public_path__ + "static/media/affiliate-1.62b7a3a1.jpg";